/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-no-target-blank */
import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import server from '../../_api/backend';
import * as toast from '../../_store/slice/toast';

export function Bookstore() {
  const [onlineItems, setOnlineItems] = useState<any>([]);
  const [offlineItems, setOfflineItems] = useState<any>([]);
  const dispatch = useDispatch();

  useEffect(() => {
    getOnlineStoreList();
    getOfflineStoreList();
  }, []);

  // 온라인 서점 리스트 가져오기
  const getOnlineStoreList = async () => {
    await server
      .getOnlineStore(1, 10000)
      .then((payload) => {
        if (!payload) {
          dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
        } else if (payload.code === 260 || payload.code === 500) {
          dispatch(toast.error({ message: '파라미터 오류' }));
        } else {
          setOnlineItems(payload.items);
        }
      })
      .catch((error) => {
        dispatch(toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' }));
        console.log(error);
      });
  };

  // 오프라인 서점 리스트 가져오기
  const getOfflineStoreList = async () => {
    await server
      .getOfflineStore(1, 10000)
      .then((payload) => {
        if (!payload) {
          dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
        } else if (payload.code === 260 || payload.code === 500) {
          dispatch(toast.error({ message: '파라미터 오류' }));
        } else {
          setOfflineItems(payload.items);
        }
      })
      .catch((error) => {
        dispatch(toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' }));
        console.log(error);
      });
  };

  return (
    <main className="sub bookstore wrapper">
      <div className="content">
        <div className="breadscrumb">
          <>Home</>
          {' > '}
          <>고객센터</>
          {' > '}
          <>서점안내</>
        </div>
        <div className="title">
          <h2>서점안내</h2>
          <p>도서출판 구민사의 서적을 만날 수 있는 온라인 서점 및 전국 오프라인 서점정보입니다.</p>
        </div>
        <section>
          <h3>온라인 서점</h3>
          <div className="links">
            {onlineItems?.map((item: any) => (
              <a href={item.urlOnline} target="_blank" key={item.id}>
                <div className="image">
                  <img
                    src={`${process.env.REACT_APP_API_URL}/public${item.imageUrl}` || ''}
                    alt={item.id}
                  />
                </div>
                <span>{item.name}</span>
              </a>
            ))}
            {/* <a href="http://www.bandinlunis.com" target="_blank">
              <div className="image">
                <img
                  src="/assets/images/logo/bookstore/bandinlunis.jpg"
                  alt="반디앤루니스 사이트 바로가기"
                />
              </div>
              <span>반디앤루니스</span>
            </a> */}
          </div>
        </section>
        <section>
          <h3>오프라인 서점</h3>
          <h4>서울지역 서점안내</h4>
          <div className="table">
            <ul className="row title">
              <li>서점명</li>
              <li>전화번호</li>
              <li>주소</li>
            </ul>
            {offlineItems?.map(
              (item: any) =>
                item.district === '서울지역' && (
                  <ul className="row title" key={item.id}>
                    <li>{item.name}</li>
                    <li>{item.tel}</li>
                    <li>{item.address}</li>
                  </ul>
                )
            )}
          </div>
        </section>
        <section>
          <h4>경기지역 서점안내</h4>
          <div className="table">
            <ul className="row title">
              <li>서점명</li>
              <li>전화번호</li>
              <li>주소</li>
            </ul>
            {offlineItems?.map(
              (item: any) =>
                item.district === '경기지역' && (
                  <ul className="row title" key={item.id}>
                    <li>{item.name}</li>
                    <li>{item.tel}</li>
                    <li>{item.address}</li>
                  </ul>
                )
            )}
          </div>
        </section>
        <section>
          <h4>충청지역 서점안내</h4>
          <div className="table">
            <ul className="row title">
              <li>서점명</li>
              <li>전화번호</li>
              <li>주소</li>
            </ul>
            {offlineItems?.map(
              (item: any) =>
                item.district === '충청지역' && (
                  <ul className="row title" key={item.id}>
                    <li>{item.name}</li>
                    <li>{item.tel}</li>
                    <li>{item.address}</li>
                  </ul>
                )
            )}
          </div>
        </section>
        <section>
          <h4>강원지역 서점안내</h4>
          <div className="table">
            <ul className="row title">
              <li>서점명</li>
              <li>전화번호</li>
              <li>주소</li>
            </ul>
            {offlineItems?.map(
              (item: any) =>
                item.district === '강원지역' && (
                  <ul className="row title" key={item.id}>
                    <li>{item.name}</li>
                    <li>{item.tel}</li>
                    <li>{item.address}</li>
                  </ul>
                )
            )}
          </div>
        </section>
        <section>
          <h4>영남지역 서점안내</h4>
          <div className="table">
            <ul className="row title">
              <li>서점명</li>
              <li>전화번호</li>
              <li>주소</li>
            </ul>
            {offlineItems?.map(
              (item: any) =>
                item.district === '영남지역' && (
                  <ul className="row title" key={item.id}>
                    <li>{item.name}</li>
                    <li>{item.tel}</li>
                    <li>{item.address}</li>
                  </ul>
                )
            )}
          </div>
        </section>
        <section>
          <h4>호남지역 서점안내</h4>
          <div className="table">
            <ul className="row title">
              <li>서점명</li>
              <li>전화번호</li>
              <li>주소</li>
            </ul>
            {offlineItems?.map(
              (item: any) =>
                item.district === '호남지역' && (
                  <ul className="row title" key={item.id}>
                    <li>{item.name}</li>
                    <li>{item.tel}</li>
                    <li>{item.address}</li>
                  </ul>
                )
            )}
          </div>
        </section>
        <section>
          <h4>제주지역 서점안내</h4>
          <div className="table">
            <ul className="row title">
              <li>서점명</li>
              <li>전화번호</li>
              <li>주소</li>
            </ul>
            {offlineItems?.map(
              (item: any) =>
                item.district === '제주지역' && (
                  <ul className="row title" key={item.id}>
                    <li>{item.name}</li>
                    <li>{item.tel}</li>
                    <li>{item.address}</li>
                  </ul>
                )
            )}
          </div>
        </section>
      </div>
    </main>
  );
}
